import { useRef, useState, useEffect } from "react";
import Image from "next/image";


const SmartPumping = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [activeSegment, setActiveSegment] = useState<number>(0);
  const [src, setSrc] = useState("");

  useEffect(() => {
    const chooseSrc = () =>
      setSrc(
        window.innerWidth >= 768
          ? process.env.NEXT_PUBLIC_STATIC_SITE + "/images/product/MMBP3201/smart-pumping.mp4"
          : process.env.NEXT_PUBLIC_STATIC_SITE + "/images/product/MMBP3201/smart-pumping-mb.mp4"
      );
    chooseSrc();
    window.addEventListener("resize", chooseSrc);
    return () => window.removeEventListener("resize", chooseSrc);
  }, []);

  const handleJump = (time: number, index: number) => {
    if (!videoRef.current) return;

    videoRef.current.currentTime = time;
    videoRef.current.play();
    setActiveSegment(index);
  };

  useEffect(() => {
    const video = videoRef.current;

    if (!video) return;

    const onTimeUpdate = () => {
      const t = video.currentTime;

      if (t < 5) setActiveSegment(0);
      else if (t < 10) setActiveSegment(1);
      else setActiveSegment(2);
    };

    video.addEventListener('timeupdate', onTimeUpdate);

    return () => {
      video.removeEventListener('timeupdate', onTimeUpdate);
    };
  }, []);

  return (
    <div className="w-full">
      <div className="relative w-full">
        <video
          ref={videoRef}
          src={src}
          className="w-full h-auto"
          autoPlay
          loop
          muted
        />
        <div className="absolute w-full top-7 md:top-8">
          <p className="text-xl font-bold text-center md:text-5xl font-poppins">Pump Smarter, Effortlessly.</p>
          <p className="text-center text-xs md:text-[27px] md:leading-normal font-poppins">Pantau, atur, dan pompa ASI dengan mudah.</p>
        </div>
        <div className="absolute w-full top-[67%] md:top-[60%]">
          <div className="relative w-full">
            <div className="absolute flex space-x-6 transform -translate-x-1/2 md:space-x-20 left-1/2">
              <div className="flex flex-col items-center">
                <div onClick={() => handleJump(0, 0)} className="relative w-12 h-12 cursor-pointer md:w-20 md:h-20">
                  <Image
                    src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/product/MMBP3201/selection-mode-white.png"}
                    alt="Selection mode"
                    width={80}
                    height={80}
                    className={`absolute inset-0 transition-transform duration-500 ease-in-out ${activeSegment === 0 ? 'opacity-0 scale-95 z-0' : 'opacity-100 scale-100 z-10'}`}
                  />
                  <Image
                    src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/product/MMBP3201/selection-mode-pink.png"}
                    alt="Selection mode"
                    width={80}
                    height={80}
                    className={`absolute inset-0 transition-transform duration-500 ease-in-out ${activeSegment === 0 ? 'opacity-100 scale-100 z-10' : 'opacity-0 scale-75 z-0'}`}
                  />
                </div>
                <p className="mt-2 text-center text-[10px] md:text-base whitespace-nowrap font-poppins">Pilihan Mode</p>
              </div>
              <div className="flex flex-col items-center">
                <div onClick={() => handleJump(5, 1)} className="relative w-12 h-12 cursor-pointer md:w-20 md:h-20">
                  <Image
                    src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/product/MMBP3201/heat-remedy-white.png"}
                    alt="Heat Remedy"
                    width={80}
                    height={80}
                    className={`absolute inset-0 transition-transform duration-500 ease-in-out ${activeSegment === 1 ? 'opacity-0 scale-95 z-0' : 'opacity-100 scale-100 z-10'}`}
                  />
                  <Image
                    src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/product/MMBP3201/heat-remedy-pink.png"}
                    alt="Heat Remedy"
                    width={80}
                    height={80}
                    className={`absolute inset-0 transition-transform duration-500 ease-in-out ${activeSegment === 1 ? 'opacity-100 scale-100 z-10' : 'opacity-0 scale-75 z-0'}`}
                  />
                </div>
                <p className="mt-2 text-center text-[10px] md:text-base whitespace-nowrap font-poppins">Heat Remedy</p>
              </div>
              <div className="flex flex-col items-center">
                <div onClick={() => handleJump(10, 2)} className="relative w-12 h-12 cursor-pointer md:w-20 md:h-20">
                  <Image
                    src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/product/MMBP3201/adjustable-level-white.png"}
                    alt="Adjustable Level"
                    width={80}
                    height={80}
                    className={`absolute inset-0 transition-transform duration-500 ease-in-out ${activeSegment === 2 ? 'opacity-0 scale-95 z-0' : 'opacity-100 scale-100 z-10'}`}
                  />
                  <Image
                    src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/product/MMBP3201/adjustable-level-pink.png"}
                    alt="Adjustable Level"
                    width={80}
                    height={80}
                    className={`absolute inset-0 transition-transform duration-500 ease-in-out ${activeSegment === 2 ? 'opacity-100 scale-100 z-10' : 'opacity-0 scale-75 z-0'}`}
                  />
                </div>
                <p className="mt-2 text-center text-[10px] md:text-base whitespace-nowrap font-poppins">Pilihan Level</p>
              </div>
            </div>
          </div>
          <div className="w-full md:w-3/4 mx-auto mt-[92px] md:mt-[180px] relative">
            <div className={`absolute inset-0 transition-opacity duration-500 ${activeSegment === 0 ? 'opacity-100' : 'opacity-0'}`}>
              <p className="text-xl md:text-[38px] md:leading-normal text-center font-poppins">Pilihan Mode</p>
              <p className="text-sm md:text-[27px] md:leading-normal text-center font-poppins">Pilih mode Pijat, Stimulasi, Ekspresi, atau Otomatis sesuai kebutuhan menyusui.</p>
            </div>
            <div className={`absolute inset-0 transition-opacity duration-500 ${activeSegment === 1 ? 'opacity-100' : 'opacity-0'}`}>
              <p className="text-xl md:text-[38px] md:leading-normal text-center font-poppins">Heat Remedy</p>
              <p className="text-sm md:text-[27px] md:leading-normal text-center font-poppins">Sensasi hangat melancarkan aliran ASI, memberi kenyamanan saat memompa & mencegah mastitis.</p>
            </div>
            <div className={`absolute inset-0 transition-opacity duration-500 ${activeSegment === 2 ? 'opacity-100' : 'opacity-0'}`}>
              <p className="text-xl md:text-[38px] md:leading-normal text-center font-poppins">Pilihan Level</p>
              <p className="text-sm md:text-[27px] md:leading-normal text-center font-poppins">Temukan tingkat level hisap yang lembut & sesuai kebutuhan Anda.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SmartPumping
